// 2BMade brand-tokens voor PDF-templates.
// Geen Plus Jakarta Sans via @react-pdf/Font register voor v1 (Helvetica werkt direct).

export const brand = {
  primary: '#1E2D3D',
  accent: '#E87C3E',
  accentSoft: '#FDE0C8',
  textMuted: '#6B7280',
  textBody: '#1F2937',
  surface: '#F8FAFC',
  border: '#E2E8F0',
  divider: '#CBD5E1',
};

export function formatEur(v: number): string {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

export function formatDateNL(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
